import React from 'react';
import { Layout, Menu, Typography } from 'antd';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import {
  KeyOutlined,
  LogoutOutlined,
  ShoppingOutlined,
  ScanOutlined,
  EnvironmentOutlined,
  TagsOutlined,
  GlobalOutlined,
  ImportOutlined,
  DashboardOutlined,
} from '@ant-design/icons';
import Logo from './Logo';
import Version from './Version';
import { logout } from '../utils/auth';

const { Content, Sider } = Layout;

const UserLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userStr = localStorage.getItem('user');
  const user = JSON.parse(userStr);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    {
      key: 'order-import',
      icon: <ImportOutlined />,
      label: '订单导入',
      onClick: () => navigate('/order-import')
    },
    {
      key: 'batch-management',
      icon: <DashboardOutlined />,
      label: '批次管理',
      onClick: () => navigate('/batch-management')
    },
    {
      key: 'my-orders',
      icon: <ShoppingOutlined />,
      label: '订单管理',
      onClick: () => navigate('/my-orders')
    },
    // {
    //   key: 'my-batches',
    //   icon: <TagsOutlined />,
    //   label: '批次管理',
    //   onClick: () => navigate('/my-batches')
    // },
    {
      key: 'scan-print',
      icon: <ScanOutlined />,
      label: '扫描打印',
      onClick: () => navigate('/scan-print')
    },
    ...(user?.can_update_address ? [{
      key: 'update-address',
      icon: <EnvironmentOutlined />,
      label: '更新地址',
      onClick: () => navigate('/update-address')
    }] : []),
    // {
    //   key: 'tracking',
    //   icon: <GlobalOutlined />,
    //   label: '包裹跟踪',
    //   onClick: () => navigate('/tracking')
    // },
    {
      key: 'change-password',
      icon: <KeyOutlined />,
      label: '更改密码',
      onClick: () => navigate('/change-password')
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    }
  ];

  // Get the current selected key from the path
  const selectedKey = location.pathname.split('/')[1] || 'my-orders';

  return (
    <Layout style={{ minHeight: '100vh', background: '#fff' }}>
      <Sider 
        width={200} 
        theme="light"
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{ height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Logo />
        </div>
        <Version />
        <div style={{ paddingLeft: '28px', paddingBottom: '16px', textAlign: 'left' }}>
          <Typography.Text strong>欢迎您，{user?.company_name}</Typography.Text>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          style={{ flex: 1, borderRight: 0 }}
          items={menuItems}
        />
      </Sider>
      <Layout style={{ marginLeft: 200, background: '#fff', minHeight: '100vh' }}>
        <Content>
          <div style={{ minHeight: 280 }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default UserLayout;
